import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { ObjectSchema, object, string } from "yup";

export type ConfirmationCodeFormValues = {
  code: string;
};

const confirmationCodeFormValidationSchema: ObjectSchema<ConfirmationCodeFormValues> = object({
    code: string()
      .required("Code field is required")
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(6, "Must be exactly 6 digits")
      .max(6, "Must be exactly 6 digits"),
  })
  .required();

export function useConfirmationCodeForm() {
  return useForm<ConfirmationCodeFormValues>({
    resolver: yupResolver(confirmationCodeFormValidationSchema),
    reValidateMode: "onChange",
  });
}
